export default __webpack_public_path__ + "static/media/together-for-gold-it.fd387d6d.png";